<script setup lang="ts">
import type { NavigationMenuItem } from '@nuxt/ui';

import {
  sidebarNavigationMenuUi,
  type SidebarNavItem,
} from '@/util/navigationMenu';

withDefaults(defineProps<{
  items: SidebarNavItem[],
  ui?: Record<string, string>,
}>(), {
  ui: () => ({ ...sidebarNavigationMenuUi }),
});

const asSidebarItem = (item: NavigationMenuItem): SidebarNavItem => item as SidebarNavItem;
</script>

<template>
  <UNavigationMenu
    orientation="vertical"
    variant="pill"
    color="neutral"
    :external-icon="false"
    :trailing-icon="undefined"
    :unmount-on-hide="false"
    :items="items as NavigationMenuItem[]"
    :ui="ui"
    class="w-full"
  >
    <template #item-leading="{ item }">
      <UiFaIcon
        v-if="asSidebarItem(item).faIcon"
        :icon="asSidebarItem(item).faIcon!"
        :size="asSidebarItem(item).isChild ? undefined : 'lg'"
        class="shrink-0 text-current"
      />
    </template>
    <template #item-label="{ item }">
      <span class="flex items-center gap-2 min-w-0">
        <span class="truncate">
          {{ item.label }}
        </span>
        <UiFaIcon
          v-if="item.target === '_blank'"
          :icon="['fal', 'arrow-up-right-from-square']"
          class="w-3 shrink-0"
        />
      </span>
    </template>
    <template #item-trailing="{ item }">
      <UiFaIcon
        v-if="item.children?.length"
        :icon="['fal', 'chevron-right']"
        class="size-4 shrink-0 text-current transition-transform duration-200 group-data-[state=open]:rotate-90"
        aria-hidden="true"
      />
    </template>
  </UNavigationMenu>
</template>
